import { render } from "./billDetail_backup.vue?vue&type=template&id=12a98257&scoped=true"
import script from "./billDetail_backup.vue?vue&type=script&lang=js"
export * from "./billDetail_backup.vue?vue&type=script&lang=js"

import "./billDetail_backup.vue?vue&type=style&index=0&id=12a98257&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a98257"]])

export default __exports__